import React from "react";

import { useSessionStorage } from "./services/useSessionStorage";

const MetadataConfigurationContext = React.createContext();

const useMetadataConfigurationContext = (client) => {
  const [context, setContext] = useSessionStorage(
    "metadataConfiguration",
    null,
  );
  if (!context) {
    console.time("Querying for Metadata Configuration");
    client
      .query(getMetadataConfigurationQuery)
      .toPromise()
      .then((response) => {
        if (response.error) throw new Error(response.error);
        setContext(response.data?.metadataConfiguration);
        console.timeEnd("Querying for Metadata Configuration");
      })
      .catch((e) => {
        if (/Token has expired\./.test(e.toString()))
          window.location.replace("/logout.html");
      });
  }
  return [context, setContext];
};

const getMetadataConfigurationQuery = `
  query GetMetadataConfiguration {
    metadataConfiguration {
      item {
        constraints {
          configurations
          filters {
            configurations
            test
            values
          }
          maxLength
          multiline
          print {
            available
            selected
          }
          readonly
          required
        }
        label
        path
        type
        ... on MetadataSelectedValueConfiguration {
          values {
            configurations
            filters {
              configurations
              test
              values
            }
            ... on MetadataSelectedUser {
              roles
              scope
            }
            ... on MetadataSelectedValue {
              abbrev
              booleanValue
              intKey
              intValue
              stringKey
              stringValue
            }
          }
        }
      }
      passage {
        constraints {
          configurations
          disablePlaceholder
          filters {
            configurations
            test
            values
          }
          maxLength
          multiline
          print {
            available
            selected
          }
          readonly
          required
        }
        label
        path
        type
        ... on MetadataSelectedValueConfiguration {
          values {
            configurations
            filters {
              configurations
              test
              values
            }
            ... on MetadataSelectedUser {
              roles
              scope
            }
            ... on MetadataSelectedValue {
              abbrev
              booleanValue
              intKey
              intValue
              stringKey
              stringValue
            }
          }
        }
      }
      templates {
        contentAreas
        html
        id
        label
        type
      }
    }
  }`;

export { MetadataConfigurationContext, useMetadataConfigurationContext };
